export { default as SyntaxHighlighter } from "./syntax-highlighter";
